
import Vue, { PropType } from 'vue';
import { SideBar } from '../SideBar';
import { CvButtonSet, CvButton, CvLoading } from '@carbon/vue';
import { ArtworkResultItem, UpdateCustomerArtwork } from '../typings';
import EditArtworkForm from './EditArtworkForm.vue';
import artworkAPI from '@/services/CustomersService';

export default Vue.extend({
  components: {
    SideBar,
    EditArtworkForm,
    CvButtonSet,
    CvButton,
    CvLoading,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    artworkId: {
      type: String,
    },
    tagOptions: {
      type: [] as PropType<string[]>,
    },
  },
  data() {
    return {
      artwork: {} as ArtworkResultItem,
      isSaveEnabled: true,
      isLoading: false,
      isShowingForm: false,
    };
  },
  computed: {
    shouldFetch(): boolean {
      return this.isOpen && this.artworkId !== '';
    },
  },
  watch: {
    shouldFetch: async function () {
      // ToDo: This has to be called somewhere else
      // this.resetModel();

      if (this.artworkId) {
        await this.getArtwork();
      }
    },
  },
  methods: {
    getArtwork: async function () {
      this.isLoading = true;

      // Don't delete this for now
      // var retrievedData: ArtworkResultItem = {
      //   id: '',
      //   title: '',
      //   fileName: '',
      //   thumbnailUrl: '',
      //   tags: [],
      //   originalFileUrl: '',
      //   pngFileUrl: '',
      //   pmsColorsInPngFile: [],
      //   spotColorsInOriginalFile: [],
      //   pngWidthPixels: 0,
      //   pngHeightPixels: 0,
      //   pngHorizontalResolutionDPIs: 0,
      //   pngVerticalResolutionDPIs: 0,
      // };

      try {
        const { data } = await artworkAPI
          .getById(this.artworkId)
          .finally(() => (this.isLoading = false));

        this.artwork = data;
      } catch (error) {
        console.log(error);
      }
    },
    patchArtwork: async function () {
      const updateArtwork: UpdateCustomerArtwork = {
        newTitle: this.artwork.title,
        newTagsList: this.artwork.tags,
      };
      artworkAPI.update(this.artworkId, updateArtwork).then(() => {
        this.$emit('action', 'edit-success', updateArtwork);
      });
    },
    resetModel() {
      this.artwork = {} as ArtworkResultItem;
      this.isShowingForm = false;
    },
    onFunction() {
      this.isShowingForm = true;
    },
    onArtworkChanged({
      isDirty,
      isValid,
    }: {
      isDirty: { title: boolean; tags: boolean };
      isValid: { title: boolean };
    }) {
      this.isSaveEnabled = isValid.title && (isDirty.title || isDirty.tags);
    },
  },
});
